import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StorageService } from 'src/app/modules/auth/services/storage.service';

export enum HTTP_ERROR {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  NOT_FOUND = 404,
  FORBIDDEN = 403,
  INTERNAL_SERVER_ERROR = 500,
}

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private toastrService: ToastrService,
    private router: Router,
    private storageService: StorageService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        return this.handleErrorMessage(error);
      })
    );
  }

  private handleErrorMessage(error: HttpErrorResponse): Observable<never> {
    let errorMessage: string;

    if (error.error instanceof Blob && error.error.type === 'text/plain') {
      errorMessage = 'No data available to export.';
    } else {
      errorMessage = this.getErrorMessage(error);
    }

    this.toastrService.error(errorMessage, 'Error');
    return throwError(errorMessage);
  }

  private logout() {
    this.storageService.clear().subscribe((res) => {
      if (res) {
        this.router.navigate(['/auth/login']);
      }
    });
  }

  private getErrorMessage(error: HttpErrorResponse): string {
    if (error.error && error.error.message) {
      return error.error.message;
    }

    switch (error.status) {
      case HTTP_ERROR.BAD_REQUEST:
        return 'Bad Request';
      case HTTP_ERROR.UNAUTHORIZED:
        this.logout();
        return 'Unauthorized';
      case HTTP_ERROR.NOT_FOUND:
        return 'Not Found';
      case HTTP_ERROR.FORBIDDEN:
        return 'Forbidden request';
      case HTTP_ERROR.INTERNAL_SERVER_ERROR:
        return 'Internal Server Error';
      default:
        return 'An error occurred';
    }
  }
}
